<template>
  <v-autocomplete
    :menu-props="{ offsetY: true, overflowY: true }"
    :placeholder="placeholder"
    :items="items"
    :item-text="itemText"
    :item-value="itemValue"
    class="niko-dropdown room-type-dropdown"
    append-icon="$iconChevronDown"
    hide-details="true"
    v-model="select"
    full-width
    outlined
    rounded
    filled
    attach
  >
    <template v-slot:item="{ item, attrs, on }">
      <v-list-item class="room-type-dropdown__item" v-on="on" v-bind="attrs">
        <div
          class="
            room-type-dropdown__content
            d-flex
            justify-space-between
            flex-fill
            align-center
            py-1
          "
        >
          <span>{{ `${item.room.type_id} ${item.room.room_type}` }}</span>
          <span
            v-if="activeSubscription"
            class="room-type-dropdown__value ml-2"
          >
            {{ `${item.room.lux || "-"}/${item.room.u0 || "-"}` }}
          </span>
        </div>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "room-type-dropdown",
  data: () => {
    return { select: undefined };
  },
  props: {
    items: Array,
    width: String,
    placeholder: String,
    height: String,
    value: Object,
    itemText: String,
    itemValue: String,
  },
  computed: {
    ...mapState("authStore", ["activeSubscription"]),
  },
  watch: {
    select(value) {
      this.$emit("onSelect", value);
    },
    value() {
      if (this.value) {
        this.select = this.value;
      }
    },
  },
  mounted() {
    if (this.value) {
      this.select = this.value;
    }
  },
};
</script>
<style lang="scss">
.room-type-dropdown {
  .v-menu__content {
    border-radius: 16px;

    &::-webkit-scrollbar {
      color: #aba499;
      width: 8px;
      height: 80%;
      border-radius: 100px !important;
      background-color: #202324;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #454a4d;
      border-radius: 100px !important;
    }

    &::-webkit-scrollbar-corner {
      background: rgba(0, 0, 0, 0);
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: #575e62;
    }

    &::-webkit-scrollbar-thumb:active {
      background-color: #484e51;
    }
  }

  &__item {
    font-size: 14px;
    line-height: 20px;
    min-height: 32px;

    &:hover {
      background: #4c4c4c;
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    }
  }

  &__content {
    border-bottom: 1px solid #4c4c4c;
    min-height: 32px;
  }

  &__value {
    font-size: 10px;
    line-height: 16px;
    letter-spacing: 1.5px;
  }

  .v-label {
    position: static !important;
  }

  .v-subheader {
    font-weight: 500;
    font-size: 10px !important;
    line-height: 16px;
    letter-spacing: 1.5px;
    color: #999999 !important;
    text-transform: uppercase;
    margin: 12px 0;
    height: initial;
    align-items: flex-end;

    &:after {
      content: "";
      flex: 1 1 auto;
      border-bottom: 1px solid #4c4c4c;
      margin: 0 0 8px 8px;
    }
  }
}
</style>
